import apiClient from "../clients/apiClient";
import { safeRequest } from "../safeRequest";

export const CategoriesService = {
  async get(clubId) {
    if (!clubId) {
      return { status: 400, data: null, message: "clubId ausente" };
    }
    return safeRequest(
      apiClient.get(`/clubs/${clubId}/categories`).then((response) => response.data),
    );
  },
  async create(clubId, payload) {
    if (!clubId) {
      return { status: 400, data: null, message: "clubId ausente" };
    }
    return safeRequest(
      apiClient
        .post(`/clubs/${clubId}/categories`, payload)
        .then((response) => response.data),
    );
  },
  async delete(clubId, categoryId) {
    if (!clubId) {
      return { status: 400, data: null, message: "clubId ausente" };
    }
    try {
      const response = await apiClient.delete(`/clubs/${clubId}/categories/${categoryId}`);
      return { status: response.status, data: null, message: null };
    } catch (error) {
      return {
        status: error?.response?.status || 500,
        data: error?.response?.data || null,
        message: error?.response?.data?.message || error?.message || "Erro desconhecido",
      };
    }
  },
};
